export const convertCase = str =>  {
    return str.replace(/([a-z]+)|([A-Z]+)/g, function(match, lower, upper){
        if(lower){
           return match.toUpperCase();
        } else {
           return match.toLowerCase();
        }
     });
}


// WEBPACK FOOTER //
// ./src/axios/util.js